// update these objects when adding or removing fields
var formSchema = function (inputFields) {
    var initialState = inputFields.reduce(function (obj, item) {
        var _a;
        return Object.assign(obj, (_a = {}, _a[item.name] = { value: item.initialValue, error: '' }, _a));
    }, {});
    var validationStateSchema = inputFields.reduce(function (obj, item) {
        var _a;
        return Object.assign(obj, (_a = {}, _a[item.name] = item.validation || {}, _a));
    }, {});
    return {
        initialState: initialState,
        validationStateSchema: validationStateSchema
    };
};
export default formSchema;
//# sourceMappingURL=form.schema.js.map